import articleFilter from './modules/flatpickr';
import faqFiter from "./modules/faqFilter";
import showMore from './modules/showMore';
import headerMenu from './modules/headerMenu';
import tariff from './modules/tariff';
import landingTariffs from './modules/landingTariffs';
import { CURRENT_LANGUAGE_CODE } from './modules/language';
import inlineRegistration from './modules/inlineRegistration';
import consultationFeedback from './modules/consultationFeedback';
import productWalkthrough from './modules/productWalkthrough';
import customerResults from './modules/customerResults';
import mobileCarousel from './modules/mobileCarousel';
import stepCarousel from './modules/stepCarousel';
import enterpriseChecks from './modules/enterpriseChecks';
import faqAccordion from './modules/faqAccordion';
import randomCards from './modules/randomCards';
import enterpriseRequest from './modules/enterpriseRequest';
import { getAdvertisingParameters } from './modules/advertisingAttribution.js';
import { tooltipInit } from "./modules/tooltip";
import processLinks from "./modules/utmHandler";
import { PhoneMask } from "./modules/phoneMask";

processLinks();

export const debounce = (func, wait) => {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

// TAB FOCUS

export let focusableElements = [];
export let firstFocusableElement, lastFocusableElement;

export let prevFocusedElement;

export const getFocusableElements = (modal) => {
  return Array.from(
    modal.querySelectorAll('input:not([type="hidden"]), button, a, [tabindex]:not([tabindex="-1"])')
  ).filter(el => !el.disabled);
}

export const setupFocusTrap = (currModal, prevFcsdEl) => {
  if (prevFcsdEl) prevFocusedElement = prevFcsdEl;
  focusableElements = getFocusableElements(currModal);
  firstFocusableElement = focusableElements[1] || focusableElements[focusableElements.length - 1];
  lastFocusableElement = focusableElements[focusableElements.length - 1];
  firstFocusableElement.focus();
}

export const handleTab = (event, currModal) => {
  focusableElements = getFocusableElements(currModal);
  const firstFocusableElement = focusableElements[0];
  const lastFocusableElement = focusableElements[focusableElements.length - 1];
  if (event.key === 'Tab') {
    if (event.shiftKey) {
      if (document.activeElement === firstFocusableElement) {
        event.preventDefault();
        lastFocusableElement.focus();
      }
    } else {
      if (document.activeElement === lastFocusableElement) {
        event.preventDefault();
        firstFocusableElement.focus();
      }
    }
  }
}
// TAB FOCUS

document.addEventListener("DOMContentLoaded", function () {
  const MODAL_ERROR = {
    ru: {
      REQUIRED: 'Обязательное поле',
      LIMIT_EXCEEDED: 'Превышение длины',
      INCORRECT_PHONE: 'Некорректный телефон',
      INCORRECT_EMAIL: 'Некорректная почта'
    },
    us: {
      REQUIRED: 'Required',
      LIMIT_EXCEEDED: 'Limit exceeded',
      INCORRECT_PHONE: 'Phone incorrect',
      INCORRECT_EMAIL: 'Email incorrect'
    },
    es: {
      REQUIRED: 'Campo obligatorio',
      LIMIT_EXCEEDED: 'Límite superado',
      INCORRECT_PHONE: 'Teléfono incorrecto',
      INCORRECT_EMAIL: 'Correo incorrecto'
    },
    pt: {
      REQUIRED: 'Campo obrigatório',
      LIMIT_EXCEEDED: 'Limite excedido',
      INCORRECT_PHONE: 'Telefone incorreto',
      INCORRECT_EMAIL: 'E-mail incorreto'
    },
    br: {
      REQUIRED: 'Campo obrigatório',
      LIMIT_EXCEEDED: 'Limite excedido',
      INCORRECT_PHONE: 'Telefone incorreto',
      INCORRECT_EMAIL: 'E-mail incorreto'
    }
  };
  const ERROR_LOCALE = MODAL_ERROR[CURRENT_LANGUAGE_CODE] || MODAL_ERROR.us;
  const SUCCESS_MODAL_VISABILITY_CLASS = 'send-success__content-vision';
  const TRY_DEMO_MODAL_VISABILITY_CLASS = 'form-info__content-vision';

  const modal = document.querySelector('.js-modal');
  const openTryDemoModalButtons = document.querySelectorAll('.js-open-try-demo-modal');

  const successModal = document.querySelector('.js-success-modal');
  const successModalCloseButton = document.querySelector('.js-success-modal-close-btn');
  const tryDemoModal = document.querySelector('.js-try-demo-modal');
  const tryDemoModalCloseButtons = document.querySelectorAll('.js-try-demo-modal-close-btn');
  const tryDemoForm = document.querySelector('.js-form-info');
  const tryDemoSubmitButton = document.querySelector('.js-try-demo-submit-button');
  const tryDemoSubmitError = tryDemoForm?.querySelector('.js-form-info-submit-error');
  let tryDemoSubmitting = false;
  const reloadPageButtons = document.querySelectorAll('.js-reload-page-btn');

  let phoneInput, emailInput, fullNameInput, phoneWrapper;

  if (tryDemoForm) {
    phoneInput = tryDemoForm.querySelector('#phone');
    phoneWrapper = phoneInput.closest(".js-phone-input-wrapper");
    emailInput = tryDemoForm.querySelector('#email');
    fullNameInput = tryDemoForm.querySelector('#full-name');
  }
  const tryDemoCheckbox = document.querySelector('.js-form-info-checkbox');
  const tryDemoCheckmark = document.querySelector('.js-form-info-checkmark');

  // ----------------------------------
  let phoneMask;
  if (phoneInput) {
    phoneMask = new PhoneMask(phoneInput, {
      showValidation: true
    });
  }

  // ----------------------------------

  const handleOverLayClick = (event) => {
    if (event.target === event.currentTarget) {
      hideModal();
      closeSuccessModal();
      closeTryDemoModal();
    }
  }

  const handleEscClose = (event) => {
    if (event.key === 'Escape') {
      hideModal();
      closeSuccessModal();
      closeTryDemoModal();
    }
  }

  const showModal = () => {
    modal.style.display = 'flex';
    document.body.style.overflowY = 'hidden';
    modal.addEventListener('mouseup', handleOverLayClick);
    window.addEventListener('keydown', handleEscClose);
  }
  const hideModal = () => {
    modal.style.display = 'none';
    document.body.style.overflowY = 'auto';
    modal.removeEventListener('mouseup', handleOverLayClick);
    window.removeEventListener('keydown', handleEscClose);
  }

  const handleTryDemoTab = (event) => {
    handleTab(event, tryDemoModal);
  }

  const handleSuccessTab = (event) => {
    handleTab(event, successModal);
  }

  const closeTryDemoModal = (clearPrevFocused = true) => {
    hideModal();
    tryDemoModal.classList.add(TRY_DEMO_MODAL_VISABILITY_CLASS);
    if (prevFocusedElement) prevFocusedElement.focus();
    if (clearPrevFocused) prevFocusedElement = null;
    tryDemoModal.removeEventListener('keydown', handleTryDemoTab);
  }

  const openSuccessModal = () => {
    showModal();
    successModal.classList.remove(SUCCESS_MODAL_VISABILITY_CLASS);
    setupFocusTrap(successModal);
    successModal.addEventListener('keydown', handleSuccessTab);
  }

  const closeSuccessModal = () => {
    hideModal();
    successModal.classList.add(SUCCESS_MODAL_VISABILITY_CLASS);
    if (prevFocusedElement) prevFocusedElement.focus();
    prevFocusedElement = null;
    successModal.removeEventListener('keydown', handleSuccessTab);
  }

  const openTryDemoModal = (event) => {
    event.preventDefault();
    const button = event.currentTarget;
    const componentId = button.getAttribute('component_id');
    const formComponentIdInput = tryDemoModal.querySelector('input[name="component_id"]');
    formComponentIdInput.value = componentId;
    if (tryDemoSubmitError) tryDemoSubmitError.hidden = true;
    showModal();
    tryDemoModal.classList.remove(TRY_DEMO_MODAL_VISABILITY_CLASS);
    setupFocusTrap(tryDemoModal, button);
    tryDemoModal.addEventListener('keydown', handleTryDemoTab);
  }

  const getCookie = (name) => {
    if (!document.cookie) return null;

    const cookie = document.cookie.split(';')
      .map(c => c.trim())
      .filter(c => c.startsWith(name + '='));

    if (cookie.length === 0) {
      return null;
    }

    return decodeURIComponent(cookie[0].split('=')[1]);
  }

  const getFormConfig = (form) => {
    const pageId = form.querySelector('input[name="page_id"]').value;
    const componentId = form.querySelector('input[name="component_id"]').value;

    return [pageId, componentId];
  }

  const handleTryDemoSubmit = async (event) => {
    event.preventDefault();
    if (tryDemoSubmitting) return;

    if (validateForm(true)) {
      tryDemoSubmitting = true;
      tryDemoSubmitButton.disabled = true;
      if (tryDemoSubmitError) tryDemoSubmitError.hidden = true;
      const url = event.target.action;
      const [pageId, componentId] = getFormConfig(event.target);
      let sent = false;
      try {
        const formData = {};
        formData.phone = phoneMask ? phoneMask.getFormattedNumber() : phoneInput.value;
        formData.email = emailInput.value;
        formData.name = fullNameInput.value;
        formData.page_id = pageId;
        formData.component_id = componentId;
        const attribution = getAdvertisingParameters();
        ['utm_campaign', 'utm_content', 'utm_medium', 'utm_source', 'utm_term'].forEach((key) => {
          if (attribution[key]) formData[key] = attribution[key];
        });

        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFTOKEN': getCookie('csrftoken'),
          },
          body: JSON.stringify(formData),
        });

        if (response.ok) {
          const result = await response.json();
          window.CargoTetrisAnalytics?.track('generate_lead');
          closeTryDemoModal(false);
          openSuccessModal();
          tryDemoForm.reset();
          sent = true;
        } else {
          if (response.status === 400) {
            const errorData = await response.json();
            if (errorData.phone) showError(phoneWrapper, errorData.phone[0]);
          }
          throw new Error(`Feedback request failed: ${response.status}`);
        }

      } catch (err) {
        if (tryDemoSubmitError) tryDemoSubmitError.hidden = false;
        console.error(err);
      } finally {
        tryDemoSubmitting = false;
        tryDemoSubmitButton.disabled = false;
        if (sent) handleSubmitButtonStatus();
      }
    }
  }

  const isInputEmpty = (formInput) => {
    return formInput.value.trim() === ""
  }

  const showError = (inputWrapper, errorText) => {
    inputWrapper.classList.add("form-info__error");
    if (errorText) {
      const inputField = inputWrapper.closest('.form-info__input-field');
      const errorItem = inputField.querySelector('.form-info__error-field');
      errorItem.classList.add('form-info__error-field_visible');
      errorItem.textContent = errorText;
    }
  }

  const clearError = (inputWrapper) => {
    inputWrapper.classList.remove("form-info__error");
    const inputField = inputWrapper.closest('.form-info__input-field');
    if (inputField) {
      const errorItem = inputField.querySelector('.form-info__error-field');
      errorItem.classList.remove('form-info__error-field_visible');
      errorItem.textContent = '';
    }
  }

  const checkPhone = (isShowErr) => {
    if (!phoneInput) return true;

    // Телефон необязателен — пустое значение считаем валидным
    if (isInputEmpty(phoneInput)) {
      clearError(phoneWrapper);
      return true;
    }

    if (phoneMask) {
      return phoneMask.validate(isShowErr);
    } else {
      // Fallback валидация если модуль не инициализирован
      const digitsOnly = phoneInput.value.replace(/\D/g, "");
      const isValid = digitsOnly.length >= 5 && digitsOnly.length <= 15;
      if (!isValid && isShowErr) {
        showError(phoneWrapper, ERROR_LOCALE.INCORRECT_PHONE);
      }
      return isValid;
    }
  }

  const validateForm = (isShowErr) => {
    let isValid;

    // Проверка телефона
    isValid = checkPhone(isShowErr);

    // Проверка e-mail
    const emailWrapper = emailInput.closest(".form-info__input-email");
    if (isInputEmpty(emailInput)) {
      if (isShowErr) showError(emailWrapper, ERROR_LOCALE.REQUIRED)
      isValid = false;
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(emailInput.value.trim())) {
        if (isShowErr) showError(emailWrapper, ERROR_LOCALE.INCORRECT_EMAIL)
        isValid = false;
      } else {
        clearError(emailWrapper);
      }
    }

    // Проверка ФИО
    // const fullNameWrapper = fullNameInput.closest(".form-info__input-fio");
    // if (isInputEmpty(fullNameInput)) {
    //   if (isShowErr) showError(fullNameWrapper, ERROR_LOCALE.REQUIRED);
    //   isValid = false;
    // } else {
    //   clearError(fullNameWrapper);
    // }

    if (!tryDemoCheckbox.checked) {
      if (isShowErr) showError(tryDemoCheckmark);
      isValid = false;
    } else {
      clearError(tryDemoCheckmark);
    }

    return isValid;
  }

  const removeErrorOnInput = (inputElement, wrapperClass) => {
    inputElement.addEventListener("input", function () {
      const wrapper = inputElement.closest(wrapperClass);
      clearError(wrapper);
    });
  }

  const handleSubmitButtonStatus = () => {
    if (tryDemoSubmitButton) tryDemoSubmitButton.disabled = tryDemoSubmitting || !validateForm(false);
  }

  const reloadPage = () => {
    location.reload();
  }

  // PhoneMask сам управляет валидацией и отображением ошибок для телефона
  if (emailInput) removeErrorOnInput(emailInput, ".form-info__input-email");
  // if (fullNameInput) removeErrorOnInput(fullNameInput, ".form-info__input-fio");
  handleSubmitButtonStatus();

  if (phoneInput && emailInput && fullNameInput) {
    [phoneInput, emailInput].forEach((input) => {
      input.addEventListener("input", handleSubmitButtonStatus);
    })
  }

  if (tryDemoCheckbox) tryDemoCheckbox.addEventListener('change', handleSubmitButtonStatus)

  if (openTryDemoModalButtons) {
    openTryDemoModalButtons.forEach((btn) => {
      btn.addEventListener('click', openTryDemoModal);
    })
  }
  if (tryDemoModalCloseButtons) {
    tryDemoModalCloseButtons.forEach((btn) => {
      btn.addEventListener('click', () => closeTryDemoModal());
    })
  }
  if (tryDemoCheckbox && tryDemoCheckmark) {
    tryDemoCheckmark.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        tryDemoCheckbox.checked = !tryDemoCheckbox.checked;
        tryDemoCheckbox.dispatchEvent(new Event('change'));
      }
    });
  }

  if (tryDemoForm) tryDemoForm.addEventListener('submit', handleTryDemoSubmit);

  if (successModalCloseButton) successModalCloseButton.addEventListener('click', closeSuccessModal);
  if (reloadPageButtons) reloadPageButtons.forEach((btn) => {
    btn.addEventListener('click', reloadPage);
  })
});

document.querySelectorAll('.rich-text table').forEach((table) => {
  if (!table.parentElement.classList.contains('rich-text__table-wrapper')) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rich-text__table-wrapper');
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  }
});

document.querySelectorAll('p').forEach(p => {
  if (p.innerHTML.trim() === '' || p.innerHTML.trim() === '&nbsp;') {
    p.style.display = 'none';
  }
});

articleFilter();
faqFiter();
showMore();
headerMenu();
tariff();
landingTariffs();
inlineRegistration();
consultationFeedback();
productWalkthrough();
randomCards();
customerResults();
mobileCarousel();
stepCarousel();
enterpriseChecks();
faqAccordion();
enterpriseRequest();
tooltipInit();
if (document.querySelector('.calculator')) {
  import('./modules/calculators').then((calculators) => {
    calculators.cargoSpaceCalculator();
    calculators.ldmCalculator();
    calculators.boxVolumeCalculator();
    calculators.axleLoadCalculator();
  });
}
